/**
 * API Wrapper with Rate Limiting
 * Wraps fetch calls to enforce rate limits
 */

import apiLimiter from './apiLimiter';

/**
 * Wrapper for fetch that enforces rate limits
 * @param {string} url - The API URL to fetch
 * @param {Object} options - Fetch options
 * @returns {Promise} - Fetch promise or rejected promise if limit exceeded
 */
export async function rateLimitedFetch(url, options = {}) {
  // Check if request is allowed
  const canRequest = apiLimiter.canMakeRequest();

  if (!canRequest.allowed) {
    const error = new Error('API rate limit exceeded');
    error.dailyRemaining = canRequest.dailyRemaining;
    error.monthlyRemaining = canRequest.monthlyRemaining;
    error.dailyCount = canRequest.dailyCount;
    error.monthlyCount = canRequest.monthlyCount;
    error.dailyLimit = canRequest.dailyLimit;
    error.monthlyLimit = canRequest.monthlyLimit;

    console.error('🚫 API Request Blocked:', {
      daily: `${canRequest.dailyCount}/${canRequest.dailyLimit}`,
      monthly: `${canRequest.monthlyCount}/${canRequest.monthlyLimit}`
    });

    throw error;
  }

  // Record the request before making it
  apiLimiter.recordRequest();

  try {
    const response = await fetch(url, options);
    return response;
  } catch (error) {
    // If fetch fails, we still counted it, but that's okay
    // The request was attempted
    throw error;
  }
}

/**
 * Get current API usage statistics
 */
export function getAPIStats() {
  return apiLimiter.getStats();
}

/**
 * Reset API usage statistics (use with caution!)
 */
export function resetAPIStats() {
  apiLimiter.resetStats();
}
